import React, { useEffect, useState } from "react";
import { InstantSearch } from "react-instantsearch";
import { PageLayout } from "../components/page-layout";
import AlgoliaSearchBar from "../components/algolia-search-bar";
import AlgoliaHits from "../components/algolia-hits";
import SearchResultsStats from "../components/search-results-stats";
import AlgoliaRefineViewSidebar from "../components/algolia-refine-view-sidebar";
import {
  getFavorites,
  addFavorite,
  removeFavorite,
} from "../services/algolia.service";
import { searchClient } from "../services/algolia.service";
import { useAuth0 } from "@auth0/auth0-react";

export const HomePage = () => {
  const [isWindowWide, setIsWindowWide] = useState(window.innerWidth >= 1200);
  const [favorites, setFavorites] = useState([]);
  const { user } = useAuth0();

  const onAddToFavorites = (item) => {
    if (!user) {
      console.log("User not authenticated");
      return;
    }

    const sub = user.sub;
    const itemId = item.objectID || item.id;

    // Check if the item is already favorited
    const isAlreadyFavorited = favorites.some(
      (favItem) => favItem.id === itemId
    );

    setFavorites((prevFavorites) => {
      if (isAlreadyFavorited) {
        // Remove from favorites
        const newFavorites = prevFavorites.filter(
          (favItem) => favItem.id !== itemId
        );
        console.log("removeFavorite", sub, item.title);
        // Use Algolia service to remove favorite
        removeFavorite(sub, itemId).catch((error) => {
          console.error("Error removing favorite:", error);
        });
        return newFavorites;
      } else {
        // Add to favorites - map Algolia hit structure to favorite item
        const favoriteItem = {
          id: itemId,
          title: item.title,
          price: item.price,
          size: item.size,
          img:
            (item.img && Array.isArray(item.img) && item.img[0]) ||
            item.cover_photo?.url ||
            item.image_url ||
            null,
          url: item.url,
          site: item.shop || item.marketplace || "grailed", // Use shop field from new structure
        };
        const newFavorites = [...prevFavorites, favoriteItem];
        console.log("addFavorite", sub, item.title);
        // Use Algolia service to add favorite
        addFavorite(sub, favoriteItem).catch((error) => {
          console.error("Error adding favorite:", error);
        });
        return newFavorites;
      }
    });
  };

  useEffect(() => {
    // Fetch favorites using Algolia service
    if (user && user.sub) {
      getFavorites(user.sub)
        .then((response) => {
          setFavorites(response.data.favorites);
          console.log("Favorites fetched:", response.data.favorites);
        })
        .catch((error) => {
          console.error("Error fetching favorites:", error);
        });
    }

    const handleResize = () => {
      const newIsWindowWide = window.innerWidth >= 1200;
      if (newIsWindowWide !== isWindowWide) {
        setIsWindowWide(newIsWindowWide);
      }
    };

    const handleScroll = () => {
      const opacity = 1 - window.scrollY / 120;
      if (window.innerWidth > 640 && window.innerWidth < 1200) {
        const desktopTitle = document.querySelector(".nav-bar__title");
        if (desktopTitle) desktopTitle.style.opacity = opacity;
      } else {
        const title = document.querySelector(".nav-bar__title-mobile");
        if (title) title.style.opacity = opacity;
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isWindowWide, user]);
  return (
    <div>
      <InstantSearch searchClient={searchClient} indexName="postalservice">
        <PageLayout>
          <div
            className="search-tools-container"
            style={{ display: "flex", flexDirection: "row" }}
          >
            <AlgoliaSearchBar />
          </div>

          {isWindowWide && <AlgoliaRefineViewSidebar />}
          {!isWindowWide && (
            <div className="inline-filters-container">
              <AlgoliaRefineViewSidebar />
            </div>
          )}
          <SearchResultsStats />
          <AlgoliaHits
            favorites={favorites}
            onAddToFavorites={onAddToFavorites}
          />
        </PageLayout>
      </InstantSearch>
    </div>
  );
};
